import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18.503 18.826",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Date",
		transform: "translate(-0.225 0.025)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				"data-name": "Rectangle 286",
				width: 17.003,
				height: 15.788,
				rx: 4.245,
				transform: "translate(0.975 2.263)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 191",
				x2: 15.788,
				transform: "translate(1.561 7.728)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 192",
				y1: 3.076,
				transform: "translate(5.533 0.725)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 3957",
				d: "M0,3.076V0",
				transform: "translate(13.376 0.725)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeWidth: 1.5
			})
		]
	})
});
export { SvgIconDate as ReactComponent };
